import { get, some } from 'lodash-es';
import type { UIMatch } from 'react-router-dom';

interface OktaRouteHandle {
    allowOktaAutoSignIn?: boolean;
}

/**
 * Route `handle` marking routes an interactive user can land on before signing in (the login entry points and
 * every permission-gated route). Only these routes may probe Okta for an existing session to auto sign-in;
 * public routes such as headless export pages must never call Okta when nobody is logged in.
 */
export const OKTA_AUTO_SIGN_IN_HANDLE: OktaRouteHandle = { allowOktaAutoSignIn: true };

export const isOktaAutoSignInAllowed = (matches: UIMatch[]): boolean =>
    some(matches, (match) => get(match.handle, 'allowOktaAutoSignIn') === true);
